import React, { ReactElement } from "react";
import TimeAgo from "react-timeago";
import { TicketMessage } from "../../../__generated__/api";

export default function SystemMessageCard({ message }: {message: TicketMessage}): ReactElement {
    const date = new Date(message.createdDate);

    return (
        <div className="text-center  ">
            <small className="text-light">
                <TimeAgo
                    date={date}
                    minPeriod={60}
                    title={`${date.toLocaleDateString()} ${date.toLocaleTimeString()}`}
                />
            </small>
            {/* eslint-disable-next-line react/no-danger */}
            <div dangerouslySetInnerHTML={{ __html: message.body.html ?? "" }} />

        </div>
    );
}
